module.exports = __webpack_public_path__ + "img/home-become-member-image.009c7379.png";